import { useTranslation } from 'react-i18next'

import { FormInputsType } from '@pages/FormCreateOrEdit/types'

import {
  GENERATOR_INPUT_TYPE,
  MAIN_OBJECT_RADIO_OPTIONS,
  MAX_INPUT_LENGTH,
  TIME_LINE_MAIN_OBJECT_GROUP_TITLE_TYPES,
} from '@constants'

import { useHandlers } from './useHandlers'

type UseInputsType = ReturnType<typeof useHandlers>

export const useMainObjectInputs = (props: UseInputsType) => {
  const { handlers, state } = props

  const {
    handleChangeMainObjectShowGroupTitleScriptDialog,
    handleChangeMainObjectGroupTitleType,
    handleChangeMainObjectType,
  } = handlers

  const { watchMainObjectGroupTitleType, watchMainObjectGroupFieldKey } = state

  const { t } = useTranslation()

  const inputs: FormInputsType[] = [
    {
      name: 'mainObject.objectType',
      inputType: GENERATOR_INPUT_TYPE.RADIO_GROUP,
      formInputContainerSx: {
        width: 'fit-content',
      },
      radioOptionsList: MAIN_OBJECT_RADIO_OPTIONS,
      label: t('timeLinesCreateOrEdit.mainObject.objectType'),
      onChangeRadio: handleChangeMainObjectType,
    },
  ]

  const groupInputs: FormInputsType[] = watchMainObjectGroupFieldKey
    ? [
        {
          name: 'mainObject.groupTitleType',
          inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
          placeholder: t('timeLinesCreateOrEdit.mainObject.groupTitleType'),
          label: t('timeLinesCreateOrEdit.mainObject.groupTitleType'),
          autocompleteOptions: TIME_LINE_MAIN_OBJECT_GROUP_TITLE_TYPES,
          onChangeAutocomplete: handleChangeMainObjectGroupTitleType,
          labelPlacement: 'top',
        },
        {
          name: 'mainObject.groupTitleScript',
          inputType: GENERATOR_INPUT_TYPE.TEXTAREA,
          placeholder: t('timeLinesCreateOrEdit.mainObject.groupTitleScript'),
          label: t('timeLinesCreateOrEdit.mainObject.groupTitleScript'),
          maxLengthInput: MAX_INPUT_LENGTH,
          readOnly: true,
          labelPlacement: 'top',
          rows: 10,
          rules: {
            maxLength: MAX_INPUT_LENGTH,
          },
          formInputContainerSx: {
            justifyContent: 'flex-end !important',
            gap: 1,
          },
          additionalBtn: {
            isEnabled: true,
            disabled: !watchMainObjectGroupTitleType?.id,
            text: 'edit',
            color: 'primary',
            variant: 'contained',
            onClick: () => handleChangeMainObjectShowGroupTitleScriptDialog(true),
          },
        },
      ]
    : []

  return {
    mainObjectInputs: inputs,
    mainObjectGroupInputs: groupInputs,
  }
}
